import React, {useState, useEffect, useRef} from 'react'
import {Select, Radio, Button, Input} from "antd"
import ZkModal from "../modal/zkModal";
import {SearchOutlined} from "@ant-design/icons";
import {Empty} from "antd/es";
import tag_empty from "../../../images/common/customer/tag/tag_empty.png";
import CloudApi from "../../cloud/cloud_api";
import Message from "../message";
import ZkSelectGroupLabel from "../../cloud/common/zkSelectGroupLabel/zkSelectGroupLabel";

const {Option} = Select;
const children = [];
const ZkLabelSelect = (props) => {
    const {
        title: title,
        valueKey: valueKey,
        setSearchParams: setSearchParams,
        setDefaultSearchParams: setDefaultSearchParams,
        resetKeys: resetKeys,
        placeholder: placeholder,
        defaultValue: defaultValue,
        filterType:filterType
    } = props;
    const [value, setValue] = useState(defaultValue);
    const ownModall = useRef(null);//绑定模态框
    const selectGroupLabel = useRef(null)
    const [radioValue, setRadioValue] = useState(1);//单选
    const [labelData, setLabelData] = useState([])//存放标签数据
    useEffect(()=>{
        let bodyData={
            name:''
        }
        CloudApi.getGroupTagQuery(bodyData,(data)=>{
            data.tagGroup.forEach((item,index)=>{
                item.tag.forEach((el,ind)=>{
                    el.flag=false
                })
            })
            setLabelData(data.tagGroup)
        })
    },[])

    /**
     * value值变化处理，并把值通过setSearchParams传递给父组件
     * @param val
     */
    function handleChange(val) {
        if (valueKey) {
            setValue(val)
            setSearchParams({[valueKey]: [val]})
        }
    }

    /**
     * 向group传递默认值
     */
    useEffect(() => {
        if (valueKey) {
            setDefaultSearchParams({[valueKey]: defaultValue});
        }
    }, []);


    //开启弹框
    function come() {
        ownModall.current.show()
    }

    //关闭弹框
    function cloneModal() {
        ownModall.current.hide()
    }

    function btnSave() {
        setRadioValue(selectGroupLabel.current.exportRadioValue())
        let radio = selectGroupLabel.current.exportRadioValue()
        let selectName=[]
        let selectId=[]
        if(selectGroupLabel.current.exportName()){
            selectName=selectGroupLabel.current.exportName()
        }
        if(selectGroupLabel.current.exportId()){
            selectId=selectGroupLabel.current.exportId()
        }
        setValue(selectName)
        setSearchParams({[valueKey]: {filterType:radio,tags:selectId}})
        ownModall.current.hide()
    }
    return (
        <div className={'sg-item'}>
            <label className='sg-item-title'>{title}</label>
            <div className={'sg-item-wraper pullDown'}>
                <Select
                    value={value}
                    mode="multiple"
                    allowClear={false}
                    showArrow={true}
                    style={{width: '100%'}}
                    placeholder={placeholder}
                    defaultValue={defaultValue}
                    onChange={handleChange.bind(this)}
                    onClick={come.bind(this)}
                    open={false}
                    maxTagCount={2}
                    removeIcon={false}
                    key={'sd'}
                >
                    {children}
                </Select>
            </div>
            <ZkModal ref={ownModall} title='选择标签' onOk={btnSave} width={'680px'}>
                <ZkSelectGroupLabel ref={selectGroupLabel} data={labelData} filterType={filterType}/>
            </ZkModal>
        </div>
    )
}
export default ZkLabelSelect